import React, { useState, useEffect } from 'react'
import { CRow, CCard, CCardHeader, CCardBody } from '@coreui/react'

import store from 'src/store'
import { getPolicies } from '../policy/Policy'

const Contact = () => {
  const [policyState, setPolicyState] = useState(store.getState().chainThatPolicy)

  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setPolicyState(store.getState().chainThatPolicy)
    })
    return () => unsubscribe()
  }, [])

  useEffect(() => {
    if (policyState === undefined) {
      // console.debug('    fetching policies')
      getPolicies()
    }
  }, [policyState])

  let policy = []
  if (policyState !== undefined) {
    policy = policyState
    // console.debug(`    policy?.length:"${policy?.length}"`)
  }
  const policyContact = policy ? (
    <>
      <h2>For Policy Questions</h2>
      <p>
        Check the <a href="/policy">Policy</a> page for information about your policy, including
        claims reporting information.
      </p>
      <p>
        If you would like more information than what is available on the Policy page, please contact
        your broker directly. We cannot directly take action or answer questions about your
        insurance policy.
      </p>
      <hr />
    </>
  ) : (
    ''
  )

  return (
    <>
      <CCard className="mb-4">
        <CCardHeader>Contact Us</CCardHeader>
        <CCardBody>
          <CRow>
            {policyContact}
            <h2>Contact Us</h2>
            <p>
              For questions related to this website, its contents and services, please contact us in
              one of the following ways:
            </p>
            <p className="mx-3">
              Email: <a href="mailto:hub-contact@fusionmga.com">hub-contact@fusionmga.com</a>
            </p>
            <p className="mx-3">
              Phone: <a href="tel:1-855-639-4427">1-855-639-4427</a>
            </p>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default Contact
